module.exports = {
      id: "news-usage",
      viewBox: "0 0 24.597 24.597",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#news",
      toString: function () {
        return this.url;
      }
    }